(() => {
  const heroes = document.querySelectorAll("[data-bavi-focus-flow-hero]");

  heroes.forEach((hero) => {
    hero.classList.add("is-visible");

    const mainCta = hero.querySelector(".bavi-focus-flow-hero__cta");
    const stickyCta = document.querySelector("[data-bavi-hero-sticky-cta]");
    const finalCta = document.querySelector(".bavi-focus-flow-waitlist");
    const footer = document.querySelector(".bavi-footer");
    let stickyFrame = null;

    if (!mainCta || !stickyCta) return;

    const updateStickyCta = () => {
      const mainCtaRect = mainCta.getBoundingClientRect();
      const finalCtaRect = finalCta?.getBoundingClientRect();
      const footerRect = footer?.getBoundingClientRect();
      const purchaseAreaReached = (finalCtaRect ? finalCtaRect.top < window.innerHeight : false)
        || (footerRect ? footerRect.top < window.innerHeight : false);
      const shouldShow = mainCtaRect.bottom < 0 && !purchaseAreaReached;

      stickyCta.hidden = !shouldShow;
    };

    const requestStickyUpdate = () => {
      window.cancelAnimationFrame(stickyFrame);
      stickyFrame = window.requestAnimationFrame(updateStickyCta);
    };

    window.addEventListener("scroll", requestStickyUpdate, { passive: true });
    window.addEventListener("resize", requestStickyUpdate, { passive: true });

    if ("IntersectionObserver" in window) {
      const observer = new IntersectionObserver(requestStickyUpdate, { threshold: 0 });
      observer.observe(mainCta);
      finalCta && observer.observe(finalCta);
      footer && observer.observe(footer);
    }

    updateStickyCta();
  });
})();
